"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContext = void 0;
const app_1 = require("app");
const FilterTypings_1 = require("../Components/Filters/FilterTypings");
var PublishedContent;
(function (PublishedContent) {
    PublishedContent["News"] = "newspage";
    PublishedContent["Events"] = "eventpage";
})(PublishedContent || (PublishedContent = {}));
class PageContext {
    static get dictionary() {
        return PageContext.data.dictionary;
    }
    static get searchDictionary() {
        return PageContext.data.dictionary;
    }
    static get filterableDictionary() {
        return PageContext.data.dictionary;
    }
    static get type() {
        return PageContext.data.type;
    }
    static get pageName() {
        return PageContext.data.pageName;
    }
    static get pageId() {
        return PageContext.data.pageId;
    }
    static get sortBy() {
        return PageContext.data.sortBy;
    }
    static get sortOptions() {
        return PageContext.data.sortOptions;
    }
    static get title() {
        return PageContext.data.title;
    }
    static get publishedContent() {
        return PageContext.data.publishedContent;
    }
    static initContext(type, element, dictionary) {
        PageContext.data = {
            dictionary,
            type,
            title: app_1.AttrService.data(element, 'page-heading'),
            pageId: app_1.AttrService.data(element, 'pageid'),
            pageName: app_1.AttrService.data(document.querySelector('.dynamic-page'), 'gtm-page'),
            sortBy: PageContext.getSortByByType(type),
            sortOptions: PageContext.getSortOptionByType(type, dictionary),
            publishedContent: PageContext.getPublishedContent(type),
        };
    }
    static getSortOptionByType(type, dictionary) {
        const defaultSort = {
            label: dictionary.sortTitleDefaultLabel,
            value: FilterTypings_1.FilterSortOptions.Default,
        };
        const titleAsc = {
            label: dictionary.sortTitleAscLabel,
            value: FilterTypings_1.FilterSortOptions.TitleAsc,
        };
        const titleDesc = {
            label: dictionary.sortTitleDescLabel,
            value: FilterTypings_1.FilterSortOptions.TitleDesc,
        };
        const startDateAsc = {
            label: dictionary.sortStartDateAscLabel,
            value: FilterTypings_1.FilterSortOptions.StartDateAsc,
        };
        const startDataDesc = {
            label: dictionary.sortStartDateDescLabel,
            value: FilterTypings_1.FilterSortOptions.StartDataDesc,
        };
        const fromNowToFuture = {
            label: dictionary.nowToFuture,
            value: FilterTypings_1.FilterSortOptions.FromNowToFuture,
        };
        const fromFutureToNow = {
            label: dictionary.futureToNow,
            value: FilterTypings_1.FilterSortOptions.FromFutureToNow,
        };
        const pastEvents = {
            label: dictionary.pastEvents,
            value: FilterTypings_1.FilterSortOptions.PastEvents,
        };
        const allSort = {
            label: dictionary.sortAllLabel,
            value: FilterTypings_1.FilterSortOptions.TitleAsc,
        };
        const softwareReleaseDateAsc = {
            label: dictionary.sortNewestToOldestLabel,
            value: FilterTypings_1.FilterSortOptions.SoftwareReleaseDateDesc,
        };
        const softwareReleaseDateDesc = {
            label: dictionary.sortOldestToNewestLabel,
            value: FilterTypings_1.FilterSortOptions.SoftwareReleaseDateAsc,
        };
        const softwareReleaseDateRelevance = {
            label: dictionary.sortRelevanceLabel,
            value: FilterTypings_1.FilterSortOptions.SoftwareReleaseDateRelevance,
        };
        let result;
        switch (type) {
            case FilterTypings_1.FilterableListTypeEnum.SearchResults:
                result = [softwareReleaseDateRelevance, softwareReleaseDateAsc, softwareReleaseDateDesc];
                break;
            case FilterTypings_1.FilterableListTypeEnum.CaseStudies:
                result = [startDateAsc, startDataDesc, allSort];
                break;
            case FilterTypings_1.FilterableListTypeEnum.News:
                result = [startDataDesc, startDateAsc, allSort];
                break;
            case FilterTypings_1.FilterableListTypeEnum.Downloads:
                result = [titleAsc, titleDesc];
                break;
            case FilterTypings_1.FilterableListTypeEnum.Products:
                result = [defaultSort, titleAsc, titleDesc];
                break;
            case FilterTypings_1.FilterableListTypeEnum.Events:
                result = [
                    fromNowToFuture,
                    fromFutureToNow,
                    pastEvents,
                    Object.assign(Object.assign({}, allSort), { value: FilterTypings_1.FilterSortOptions.StartDataDesc }),
                ];
                break;
        }
        return result;
    }
    static getSortByByType(type) {
        let result;
        switch (type) {
            case FilterTypings_1.FilterableListTypeEnum.CaseStudies:
            case FilterTypings_1.FilterableListTypeEnum.News:
                result = FilterTypings_1.FilterSortOptions.StartDataDesc;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Downloads:
                result = FilterTypings_1.FilterSortOptions.TitleAsc;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Products:
                result = FilterTypings_1.FilterSortOptions.Default;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Events:
                result = FilterTypings_1.FilterSortOptions.FromNowToFuture;
                break;
            case FilterTypings_1.FilterableListTypeEnum.SearchResults:
                result = FilterTypings_1.FilterSortOptions.SoftwareReleaseDateRelevance;
                break;
        }
        return result;
    }
    static getPublishedContent(type) {
        let result = '';
        switch (type) {
            case FilterTypings_1.FilterableListTypeEnum.News:
                result = PublishedContent.News;
                break;
            case FilterTypings_1.FilterableListTypeEnum.Events:
                result = PublishedContent.Events;
                break;
        }
        return result;
    }
}
exports.PageContext = PageContext;
PageContext.data = {};
